import { render, staticRenderFns } from "./TrainingsPagesContainer.vue?vue&type=template&id=266c2923&"
import script from "./TrainingsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./TrainingsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports